import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=3abb3d44&scoped=true"
import script from "./AccountSettings.vue?vue&type=script&lang=ts"
export * from "./AccountSettings.vue?vue&type=script&lang=ts"
import style0 from "./AccountSettings.vue?vue&type=style&index=0&id=3abb3d44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abb3d44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3abb3d44')) {
      api.createRecord('3abb3d44', component.options)
    } else {
      api.reload('3abb3d44', component.options)
    }
    module.hot.accept("./AccountSettings.vue?vue&type=template&id=3abb3d44&scoped=true", function () {
      api.rerender('3abb3d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/AccountSettings.vue"
export default component.exports